import { render, staticRenderFns } from "./back-school-sale.vue?vue&type=template&id=53148d2f&scoped=true&"
import script from "./back-school-sale.vue?vue&type=script&lang=js&"
export * from "./back-school-sale.vue?vue&type=script&lang=js&"
import style0 from "./back-school-sale.vue?vue&type=style&index=0&id=53148d2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53148d2f",
  null
  
)

export default component.exports